module.exports = __webpack_public_path__ + "img/field-hockey-stick-ball.43ae76f6.svg";